import { publish } from '@shared/hooks/helpers/EventCallback';
import { useCurrentUserStore } from '@shared/hooks/state/CurrentUserContainer';
import { useEffect } from 'react';
import { useAuthStore } from '../../hooks/state/AuthContainer';

const TokenRefresher = () => {
    const REFRESH_MS = 25 * 60 * 1000; // 25 mins

    useEffect(() => {
        const interval = setInterval(async () => {
            if (!useAuthStore.getState().isLoading) {
                await useAuthStore.getState().getNewToken();
                await useCurrentUserStore.getState().loadUserLicenseAccess();
                publish('force-reconnect');
            }
        }, REFRESH_MS);

        return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
    }, []);

    return <></>;
};

export default TokenRefresher;
